import { routes } from '../constants';

const index = routes.CMS.DEFAULT;

export const CMS_CONFIG = {
	PRODUCT_INFO: [
		{
			id: 'piProductCode',
			label: 'Productcode (optioneel)',
			key: 'productCode',
		},
		{
			id: 'piDimensions',
			label: 'Afmetingen (optioneel)',
			key: 'dimensions',
		},
		{
			id: 'piWeight',
			label: 'Gewicht (optioneel)',
			key: 'weight',
		},
		{
			id: 'piKrachtMotor',
			label: 'Vermogen (optioneel)',
			key: 'motorPower',
		},
		{
			id: 'piZuigkracht',
			label: 'Max onderdruk (optioneel)',
			key: 'vacumePower',
		},
		{
			id: 'piLuchtdebiet',
			label: 'Max. luchtdebiet (optioneel)',
			key: 'maxAirDebit',
		},
		{
			id: 'piFilteroppervalk',
			label: 'Filteroppervlak (optioneel)',
			key: 'filterSurface',
		},
		{
			id: 'piFiltermateriaal',
			label: 'Filtermateriaal (optioneel)',
			key: 'filterMaterial',
		},
		{
			id: 'piOpeningInlaat',
			label: 'Opening inlaat (optioneel)',
			key: 'openingIntake',
		},
		{
			id: 'piDecibel',
			label: 'Decibel (optioneel)',
			key: 'decibel',
		},
		{
			id: 'piStofbak',
			label: 'Stofbak (optioneel)',
			key: 'dustContainer',
		},
		{
			id: 'piStroomVoorziening',
			label: 'Stroom voorziening (optioneel)',
			key: 'powerSupply',
		},
	],
	PRODUCT_CATEGORIES: [
		{
			title: 'Huishoudelijk',
			href: `${index}${routes.CMS.PRODUCTS}/household`,
			description: 'Vind hier alle producten van huishoudelijk',
		},
		{
			title: 'Industrieel',
			href: `${index}${routes.CMS.PRODUCTS}/industrial`,
			description: 'Vind hier alle producten van industrieel',
		},
		{
			title: 'Huren',
			href: `${index}${routes.CMS.PRODUCTS}/rent`,
			description: 'Vind hier alle producten van verhuur',
		},
	],
	LINKS: [
		{
			title: 'producten',
			href: `${index}${routes.CMS.PRODUCTS}`,
			description: 'producten pagina info',
		},
		{
			title: 'documenten',
			href: `${index}${routes.CMS.DOCUMENTS}`,
			description: 'Documenten pagina info',
		},
		{
			title: 'projecten',
			href: `${index}${routes.CMS.PROJECTS}`,
			description: 'Projecten pagina info',
		},
		{
			title: 'referenties',
			href: `${index}${routes.CMS.REFERENCE}`,
			description: 'Referenties pagina info',
		},
		{
			title: 'veel gestelde vragen',
			href: `${index}${routes.CMS.FAQ}`,
			description: 'Veel gestelde vragen',
		},
		{
			title: 'gebruikers',
			href: `${index}${routes.CMS.USERS}`,
			description: 'Gebruikers pagina info',
		},
		{
			title: 'vertaling',
			href: `${index}${routes.CMS.PO}`,
			description: 'upload de vertalingen voor de website',
		},
	],
	PRODUCT: {
		header: {
			overview: {
				title: 'Producten overzicht',
				description: 'Overzicht van alle producten.',
				buttonName: 'Nieuw product',
			},
			create: {
				title: 'Create product',
				description: `Maak of bewerk een product.
				Product kan enkel opgeslagen worden als alle verplichte velden en elke taal is ingevuld`,
			},
		},
		table: {
			columns: [
				'Titel',
				'Categorie',
				'Type',
			],

		},
	},
	DOCUMENTS: {
		header: {
			overview: {
				title: 'Documenten overzicht',
				description: 'Overzicht van alle Documenten.',
				buttonName: 'Nieuw document',
			},
			create: {
				title: 'Create documenten',
				description: 'Voeg een nieuw document toe. Alle velden buiten de afbeelding zijn verplicht',
			},
		},
		table: {
			columns: [
				'Titel',
			],

		},
	},
	PROJECTS: {
		header: {
			overview: {
				title: 'projecten overzicht',
				description: 'Overzicht van alle projecten.',
				buttonName: 'Nieuwe project',
			},
			create: {
				title: 'Create project',
				description: `Maak of bewerk een project.
				Project kan enkel opgeslagen worden als alle velden en elke taal ingevuld zijn`,
			},
		},
		table: {
			columns: [
				'Titel',
			],

		},
	},
	REFERENCE: {
		header: {
			overview: {
				title: 'Referenties overzicht',
				description: 'Overzicht van alle referenties.',
				buttonName: 'Nieuwe referentie',
			},
			create: {
				title: 'Create reference',
				description: 'Voeg een nieuwe referentie toe. Alle velden zijn verplicht',
			},
		},
		table: {
			columns: [
				'Logo',
				'Naam',
			],

		},
	},
	FAQ: {
		header: {
			overview: {
				title: 'Veel gestelde vragen',
				description: 'overzicht van alle vragen secties',
				buttonName: 'Nieuwe vraag sectie',
			},
			section: {
				title: 'Veel gestelde vragen sectie',
				description: `overzicht van alle vragen in deze sectie.
				De titel moet eerst in enkel taal ingevuld worden voor deze opgeslagen kan worden`,
				buttonName: 'Nieuwe vraag',
			},
			create: {
				title: 'Create een vragen',
				description: `Voeg een vraag toe.
				Vraag kan enkel opgeslagen worden als alle velden en elke taal ingevuld zijn`,
				buttonName: 'Nieuwe vraag',
			},
		},
		table: {
			columns: [
				'Titel',
			],

		},
	},
	USERS: {
		header: {
			overview: {
				title: 'Gebruikers overzicht',
				description: 'Overzicht van alle gebruikers die toegang hebben tot het cms.',
				buttonName: 'Nieuwe gebruiker',
			},
			create: {
				title: 'Create a user',
				description: 'Voeg een nieuwe gebruiker toe. Alle velden zijn verplicht',
			},
		},
		table: {
			columns: [
				'Gebruikersnaam',
			],

		},
	},
	PO: {
		header: {
			overview: {
				title: 'Vertaling',
				description: 'Upload de vertaling voor de website',
				buttonName: 'Download pot file',
			},
		},
		table: {
			columns: [
				'Gebruikersnaam',
			],

		},
	},
	CREATE: {
		product: (languages) => {
			let fields = [
				{ field: 'featuredImage', required: true },
				{ field: 'images', required: false },
				{ field: 'document', required: false },
				{ field: 'relatedProducts', required: false },
				{ field: 'projects', required: false },
				{ field: 'atex', required: false },
				{ field: 'productCategoryId', required: true },
				{ field: 'id', required: false },
				{ field: 'type', required: false },
				{ field: 'productTypeUuid', required: true },
				{ field: 'videoLink', required: false },
				{ field: 'featuredOrder', required: true },
				{ field: 'webshop', required: false },
				{ field: 'price', required: false },
			];
			languages.forEach((lang) => {
				fields = fields.concat([
					{ field: `${lang.uuid}-name`, required: true },
					{ field: `${lang.uuid}-slug`, required: true },
					{ field: `${lang.uuid}-description`, required: true },
					{ field: `${lang.uuid}-uuid`, required: false },
					{ field: `${lang.uuid}-filterSurface`, required: false },
					{ field: `${lang.uuid}-powerSupply`, required: false },
					{ field: `${lang.uuid}-motorPower`, required: false },
					{ field: `${lang.uuid}-vacumePower`, required: false },
					{ field: `${lang.uuid}-airFlowRate`, required: false },
					{ field: `${lang.uuid}-requredAirPressure`, required: false },
					{ field: `${lang.uuid}-maxCounterPressure`, required: false },
					{ field: `${lang.uuid}-maxAirDebit`, required: false },
					{ field: `${lang.uuid}-airOutput`, required: false },
					{ field: `${lang.uuid}-openingIntake`, required: false },
					{ field: `${lang.uuid}-filterMaterial`, required: false },
					{ field: `${lang.uuid}-dustContainer`, required: false },
					{ field: `${lang.uuid}-decibel`, required: false },
					{ field: `${lang.uuid}-productCode`, required: false },
					{ field: `${lang.uuid}-dimensions`, required: false },
					{ field: `${lang.uuid}-weight`, required: false },
					{ field: `${lang.uuid}-seoTitle`, required: false },
					{ field: `${lang.uuid}-seoDescription`, required: false },
				]);
			});

			return fields;
		},
		document: [
			{ field: 'uuid', required: false },
			{ field: 'type', required: false },
			{ field: 'productTypeUuid', required: true },
			{ field: 'name', required: true },
			{ field: 'document', required: true },
			{ field: 'image', required: false },
		],
		project: (languages) => {
			const fields = [
				{ field: 'id', required: false },
				{ field: 'featuredImage', required: true },
				{ field: 'cardImage', required: true },
			];
			languages.forEach((lang) => {
				fields.push({ field: `${lang.uuid}-name`, required: true });
				fields.push({ field: `${lang.uuid}-slug`, required: true });
				fields.push({ field: `${lang.uuid}-rteText`, required: true });
				fields.push({ field: `${lang.uuid}-seoTitle`, required: false });
				fields.push({ field: `${lang.uuid}-seoDescription`, required: false });
			});
			return fields;
		},
		reference: [
			{ field: 'uuid', required: false },
			{ field: 'name', required: true },
			{ field: 'url', required: true },
			{ field: 'featuredImage', required: true },
		],
		faqCat: (languages) => {
			const fields = [
				{ field: 'id', required: false },
			];
			languages.forEach((lang) => {
				fields.push({ field: `${lang.uuid}-name`, required: true });
			});
			return fields;
		},
		faq: (languages) => {
			const fields = [
				{ field: 'id', required: false },
			];
			languages.forEach((lang) => {
				fields.push({ field: `${lang.uuid}-title`, required: true });
				fields.push({ field: `${lang.uuid}-description`, required: true });
				fields.push({ field: `${lang.uuid}-faqcategoryUuid`, required: true });
			});
			return fields;
		},
		user: [
			{ field: 'uuid', required: false },
			{ field: 'username', required: true },
			{ field: 'password', required: true, errorMessage: 'er' },
		],
	},
	PRODUCT_TYPE_LABELS: {
		'1270b30c-5128-4425-a909-f1f1629b3bb7': 'Huishoudelijk',
		'02886b55-6be7-4a06-b1f3-497fbfc4acf6': 'Industrieel',
		'fee1bd47-a664-4964-9c6a-da3c4ae46fb1': 'Verhuur',
	},
	PRODUCT_TYPE_LABELS_EN: {
		'1270b30c-5128-4425-a909-f1f1629b3bb7': 'household',
		'02886b55-6be7-4a06-b1f3-497fbfc4acf6': 'industrial',
		'fee1bd47-a664-4964-9c6a-da3c4ae46fb1': 'rent',
	},
};



// WEBPACK FOOTER //
// ./src/config/cms.config.js